import "./HeavyMachinery.module.css";
import Header from "@/reusable_sections/Header";
import UnleashThePowerOfProGroupsHeavyMachinery from "./sections/UnleashThePowerOfProGroupsHeavyMachinery";
import ExploreOurHeavyMachineryLineup from "./sections/ExploreOurHeavyMachineryLineup";
import Footer from "@/reusable_sections/Footer";
export default function HeavyMachineryPage() {
  return <div>
      <Header />
      <UnleashThePowerOfProGroupsHeavyMachinery />
      <ExploreOurHeavyMachineryLineup />
      <Footer />
    </div>;
}